export default "__VITE_ASSET__CcHC9l$4__"